import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { ApiConfig } from '@ajin/config/api.config';
import { Observable, ReplaySubject, tap } from 'rxjs';
import { AppService } from '@ajin/services/app.service';
import { ObjectFunctions } from '@ajin/functions/object.functions';

@Injectable({
	providedIn: 'root'
})
export class NavigationService {
	private _navigation: ReplaySubject<FuseNavigationItem[]> = new ReplaySubject<FuseNavigationItem[]>(1);

	constructor(
		private app: AppService,
		private httpClient: HttpClient
	) {
	}

	get navigation$(): Observable<FuseNavigationItem[]> {
		return this._navigation.asObservable();
	}

	load(): Observable<FuseNavigationItem[]> {
		const url = ApiConfig.url + 'menus/' + this.app.config.id;
		return this.httpClient
			.get(url).pipe(
				tap((result: any) => {
					for (const item of result?.items) {
						// item.queryParams = { type: 5020001 };

						if (item?.queryParams) {
							item.queryParams = JSON.parse(item.queryParams);
						}
					}

					// if (this.app?.credential?.company?.code == 602106080) {
					// 	let dash = ObjectFunctions.copy(result.items[0]);
					// 	dash.link = "/dashboard"
					// 	dash.title = "Dashboard"
					// 	dash.icon = "mat_outline:dashboard",
					// 		result.items.unshift(dash)
					// }
					// else if (this.app?.credential?.company?.code == 846100819) {
					// 	let dash = ObjectFunctions.copy(result.items[0]);
					// 	dash.link = "/dashboard"
					// 	dash.title = "Dashboard"
					// 	dash.icon = "mat_outline:dashboard",
					// 		result.items.unshift(dash)
					// }
					this._navigation.next(result.items);
				})
			);
	}
}
